import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProblemApiService } from 'src/app/services/api/problem-api.service';

@Component({
  selector: 'app-support2-panel',
  templateUrl: './support2-panel.component.html',
  styleUrls: ['./support2-panel.component.scss'],
})
export class Support2PanelComponent implements OnInit {
  @Output() back = new EventEmitter<any>();
  @Input() platformInfo: any;
  /** 新手教程演示数据（问题分类树）：提供时不请求真实接口 */
  @Input() demoData: any[] | null = null;
  @Output() next = new EventEmitter<any>();

  index = 0;
  data: any = [];

  constructor(private api: ProblemApiService) {}

  ngOnInit(): void {
    if (this.demoData) {
      this.loading = false;
      this.data = this.demoData;
      return;
    }
    this.findProblemTickets();
  }

  selectTab(i: number) {
    this.index = i;
  }

  backStep() {
    this.back.emit(1);
  }

  chooseIssue(info: any) {
    this.next.emit(info);
  }

  loading = false;
  async findProblemTickets() {
    try {
      this.loading = true;
      const r = await this.api.findProblemTree(this.platformInfo.platform_id);
      this.data = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  tag(txt: string) {
    const m: any = {
      fast: '快速处理',
      manual: '可能需人工',
      selftag: '自助处理',
      accounttag: '售后校验',
    };
    return m[txt] || null;
  }
}
